import React, { Component } from 'react';
import Select from 'react-select';
import ReactSVG from 'react-svg';
import { Link, StaticQuery, graphql } from 'gatsby';
import logo from '../assets/images/md-logo-web-inline.png';

// @TODO find an established UI framework instead
class SidebarItem extends Component {
  render() {
    // const className = (this.props.activePage === this.props.value) ? 'active' : '';
    const { activeEntity, value, activeYear, icon, title, entities, years} = this.props;
    const year = years.find(({value}) => value === activeYear);
    const entity = entities.find(({value}) => value === activeEntity);
    return (
      <li>
        <Link
          disabled={activeEntity === false || null}
          to={`/${value}`}
          activeClassName='active'
          state={{
            activeEntity,
            activeYear,
            entity,
            year
          }}
        >
          <ReactSVG src={`/images/${icon}`} />
          <span>{title}</span>
        </Link>
      </li>
    );
  }
}

SidebarItem.defaultProps = {
  years: [],
  entities: []
};

class Sidebar extends Component {
  render() {
    const { menu, entities, years, activePage, activeEntity, activeYear, onPageChange, onEntityChange, onYearChange} = this.props;
    const menuMain = menu.filter(item => item.menu === 'main');
    const menuEntity = menu.filter(item => item.menu === 'entity');
    const options = entities.map(({name, id}) => ({
      label: name,
      value: id,
    }));
    const yearsdatabase = JSON.parse(years.file.childRawCode.content) || [];
    const yearOptions = yearsdatabase.map(({year, uuid}) => ({
      label: year,
      value: uuid,
    }));

    return (
      <aside className='sidebar'>
        <img src={logo} className='sidebar-logo' alt='MasterDocs' />
        <ul>
          {menuMain.map((item, index) => (
            <SidebarItem
              activePage={activePage}
              icon={item.icon}
              key={index}
              onChange={onPageChange}
              title={item.title}
              value={item.component}
            />
          ))}
        </ul>
        <h2>Entity</h2>
        <Select
          className='search-entity'
          classNamePrefix='search-entity'
          // value={selectedOption}
          onChange={onEntityChange}
          options={options}
        />
        <h2 className='search-year-title'>Year</h2>
        <Select
          className='search-year'
          classNamePrefix='search-year'
          onChange={onYearChange}
          options={yearOptions}
        />
        <ul>
          {menuEntity.map((item, index) => (
            <SidebarItem
              activeEntity={activeEntity}
              activeYear={activeYear}
              activePage={activePage}
              entities={options}
              years={yearOptions}
              icon={item.icon}
              key={index}
              onChange={onPageChange}
              title={item.title}
              value={item.component}
            />
          ))}
        </ul>
      </aside>
    );
  }
}

const WrappedSidebar = (props) => {
  return (
    <StaticQuery
      query={graphql`
      query Years {
        file(base: {eq: "yeardatabase.json"}) {
          id
          childRawCode {
            content
          }
        }
      }
      `}
      render={(years) => {
        return (
          <Sidebar years={years} {...props} />
        );
      }}
    />
  );
};

export default WrappedSidebar;
